import './ButtonsBlockRow.css';
import React from 'react';
import { Button } from 'ui-library';
import { getDataOrAriaProps } from '../../utils';

const ButtonsBlockRow = (props) => {
    const {
        leftButton,
        additionalButton,
        primaryButton,
        additionalComponent,
        children,
    } = props;

    return (
        <div className="buttons-block-row">
            {children && (
                <div className="buttons-block__content">{children}</div>
            )}
            <div className="buttons-block__col">
                {leftButton && (
                    <Button
                        type={leftButton?.type || 'secondary'}
                        size="small"
                        loading={leftButton?.loading}
                        disabled={leftButton?.disabled}
                        onClick={leftButton?.onClick}
                        {...getDataOrAriaProps(leftButton)}
                        data-cy="layout_left_button"
                    >
                        {leftButton.text}
                    </Button>
                )}
            </div>
            <div className="buttons-block__col">
                {additionalButton && (
                    <Button
                        type={additionalButton?.type || 'secondary'}
                        size="small"
                        loading={additionalButton?.loading}
                        disabled={additionalButton?.disabled}
                        onClick={additionalButton?.onClick}
                        {...getDataOrAriaProps(additionalButton)}
                        data-cy="layout_additional_button"
                    >
                        {additionalButton.text}
                    </Button>
                )}
                {additionalComponent}
                {primaryButton && (
                    <Button
                        type={primaryButton?.type || 'primary'}
                        size="small"
                        loading={primaryButton?.loading}
                        disabled={primaryButton?.disabled}
                        onClick={primaryButton?.onClick}
                        {...getDataOrAriaProps(primaryButton)}
                        data-cy="layout_continue_button"
                    >
                        {primaryButton.text}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ButtonsBlockRow;
